import { normalizePublicRouteDataPath, } from "../core/index.js";
export const PUBLIC_HYDRATION_PROTOCOL_VERSION = 1;
function isObject(value) {
    return typeof value === "object" && value !== null;
}
export function createPublicHydrationState(options) {
    return {
        publicSite: {
            protocolVersion: options.protocolVersion ?? PUBLIC_HYDRATION_PROTOCOL_VERSION,
            ...(options.buildId === undefined ? {} : { buildId: options.buildId }),
            ...(options.routeData === undefined ? {} : { routeData: options.routeData }),
        },
        application: options.application,
    };
}
export function createPublicRenderStateCreator(options) {
    return (url, locale, data = {}, context = {}) => {
        const path = normalizePublicRouteDataPath(url);
        const status = context.status ?? "ready";
        const routeData = status === "ready"
            ? {
                status: "ready",
                path,
                data,
                ...(context.canonicalPath === undefined ? {} : { canonicalPath: context.canonicalPath }),
                ...(context.generatedAt === undefined ? {} : { generatedAt: context.generatedAt }),
                ...(context.expiresAt === undefined ? {} : { expiresAt: context.expiresAt }),
            }
            : status === "not-found"
                ? {
                    status: "not-found",
                    path,
                }
                : {
                    status: "unavailable",
                    path,
                    ...(context.retryAfter === undefined ? {} : { retryAfter: context.retryAfter }),
                };
        return createPublicHydrationState({
            application: options.createApplicationState(path, locale),
            routeData,
            protocolVersion: options.protocolVersion,
        });
    };
}
export function isPublicHydrationState(value) {
    if (!isObject(value) || !isObject(value["publicSite"]) || !isObject(value["application"]))
        return false;
    const publicSite = value["publicSite"];
    return typeof publicSite["protocolVersion"] === "number"
        && (publicSite["buildId"] === undefined
            || typeof publicSite["buildId"] === "string");
}
export function createPublicHydrationProtocol(options) {
    const protocolVersion = options.protocolVersion ?? PUBLIC_HYDRATION_PROTOCOL_VERSION;
    if (!Number.isSafeInteger(protocolVersion) || protocolVersion < 1)
        throw new Error("protocolVersion must be a positive safe integer.");
    if (!options.buildId)
        throw new Error("buildId must be a non-empty string.");
    const isCompatible = (value) => {
        if (!isPublicHydrationState(value))
            return false;
        return value.publicSite.protocolVersion === protocolVersion
            && value.publicSite.buildId === options.buildId
            && (options.validateApplicationState?.(value.application)
                ?? true);
    };
    const stamp = (state) => {
        state.publicSite.protocolVersion = protocolVersion;
        state.publicSite.buildId = options.buildId;
        return state;
    };
    return {
        buildId: options.buildId,
        protocolVersion,
        create(application, routeData) {
            return createPublicHydrationState({
                application,
                routeData,
                buildId: options.buildId,
                protocolVersion,
            });
        },
        stamp,
        isCompatible,
        getRouteData(value) {
            return isCompatible(value)
                ? value.publicSite.routeData
                : undefined;
        },
    };
}
//# sourceMappingURL=index.js.map